<template>
  <div class="register-container">
    <!-- 背景层 -->
    <div class="background-layer">
      <div class="gradient-bg"></div>
      <div class="hexagon-pattern"></div>
    </div>
    
    <!-- 内容区域 -->
    <div class="content-wrapper">
      <!-- Logo和品牌区域 -->
      <header class="login-header" :style="{paddingTop: statusBarHeight + 'px'}">
        <div class="login-header-content">
          <div class="logo-wrapper" @click="ecg()">
            <img class="logo-img" src="@/assets/login/Headicon.png" alt="大救星" />
            <div class="logo-badge">
              <!-- <img src="@/assets/login/HeadSubtitleBackground.png" alt="健康版" class="badge-bg" />
              <span class="badge-text">健康版</span> -->
            </div>
          </div>
          <div class="app-name">大救星</div>
          <!-- 特性标签 -->
          <div class="features">
            <div class="feature-item">
              <img src="@/assets/login/Securityicon.png" alt="安全" class="feature-icon" />
              <span class="feature-text">安全</span>
            </div>
            <div class="feature-item">
              <img src="@/assets/login/Accurateicon.png" alt="精准" class="feature-icon" />
              <span class="feature-text">精准</span>
            </div>
            <div class="feature-item">
              <img src="@/assets/login/Healthicon.png" alt="健康" class="feature-icon" />
              <span class="feature-text">健康</span>
            </div>
          </div>
        </div>
      </header>

      <!-- 注册表单卡片 -->
      <div class="register-card">
        <div class="card-title">用户注册</div>
        <div class="card-intro">身份信息将影响您的权益获取,请真实填写</div>
        
        <!-- 真实姓名输入框 -->
        <div class="input-field">
          <div class="input-label">真实姓名</div>
          <div class="input-content">
            <el-input 
              class="register-input"
              placeholder="请输入您的真实姓名" 
              v-model="realName" 
              clearable>
            </el-input>
          </div>
        </div>

        <!-- 证件号输入框 -->
        <div class="input-field">
          <div class="input-label">证件号</div>
          <div class="input-content">
            <el-input 
              class="register-input"
              placeholder="请输入您的证件号" 
              v-model="idNumber" 
              @blur="parseIdCardInfo"
              clearable>
            </el-input>
          </div>
        </div>

        <!-- 手机号输入框 -->
        <div class="input-field">
          <div class="input-label">手机号</div>
          <div class="input-content">
            <el-input 
              class="register-input"
              placeholder="请输入您的手机号" 
              v-model="phone" 
              clearable>
            </el-input>
          </div>
        </div>

        <!-- 验证码输入框 -->
        <div class="input-field">
          <div class="input-label">验证码</div>
          <div class="input-content verify-code-content">
            <el-input 
              class="register-input"
              placeholder="请输入验证码" 
              v-model="verifyCode" 
              maxlength="6"
              clearable>
            </el-input>
            <div 
              class="verify-code-btn" 
              :class="{ 'disabled': disabled }"
              v-if="title=='获取验证码'" 
              @click.stop="getCode()">
              {{title}}
            </div>
            <div class="verify-code-btn disabled" v-else @click.stop>{{title}}</div>
          </div>
        </div>

        <!-- 注册按钮 -->
        <button class="register-btn" @click="register()">立即注册</button>

        <!-- 用户协议 -->
        <div class="agreement-section">
          <div class="agreement-checkbox" @click="act = !act">
            <div class="checkbox-icon" :class="{ 'checked': act }">
              <img v-if="act" src="../login/img/Selected.png" alt="已选" />
              <img v-else src="../login/img/notselected.png" alt="未选" />
            </div>
            <span class="agreement-text">
              我已阅读并同意<span class="link-text" @click.stop="agreement()">《用户协议》</span>和<span class="link-text" @click.stop="agreement()">《隐私政策》</span>
            </span>
          </div>
        </div>

        <!-- 已有账号，去登录 -->
        <div class="login-link-section">
          <span class="login-link-text">已有账号，<span class="login-link-btn" @click="goToLogin">去登录</span></span>
        </div>
      </div>

      
    </div>
  </div>
</template>

<script>
// stores
import { mapActions, mapState } from 'pinia';
import { useUserStore } from '@/stores/user';
import { useGlobalStore } from '@/stores/global';
// service
import { pin, register } from '@/api/activity'
import {
  clearLandingByBindingFlag,
  markLandingByBindingDone,
  resolveLandingLocation
} from '@/utils/landingRoute'

export default {
  data() {
    return {
      act: false,
      realName: "",
      idNumber: "",
      phone: "",
      verifyCode: "",
      second: "", //倒计时
      disabled: false, //是否禁用按钮
      timer: null, //计时器
      sex: null, // 从身份证号解析出的性别：1-男，2-女
      birthday: "", // 从身份证号解析出的出生日期
    };
  },
  mounted() {
    document.title = '用户注册'
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
  },
  computed: {
    ...mapState(useGlobalStore, ['statusBarHeight']),
    title() {
      return this.disabled ? `${this.second}s` : "获取验证码";
    },
  },
  watch: {
    /**
     * 监听身份证号变化，当被清空时重置解析结果
     */
    idNumber(newVal) {
      if (!newVal || newVal.trim() === '') {
        this.sex = null;
        this.birthday = "";
      }
    }
  },
  methods: {
    ecg() {
      window.location.href = 'https://work.weixin.qq.com/kfid/kfcd095e9dac59f04c3'
    },
    /**
     * 注册方法
     */
    register() {
      if(!this.act) {
        this.$message.error('请阅读用户隐私协议');
        return
      }
      if(!this.realName || !String(this.realName).trim()) {
        this.$message.error('请输入真实姓名');
        return
      }
      if(!this.idNumber || !String(this.idNumber).trim()) {
        this.$message.error('请输入证件号');
        return
      }
      if(!this.isValidID(String(this.idNumber).trim())) {
        this.$message.error('请输入正确的证件号');
        return
      }
      if(!this.phone) {
        this.$message.error('请输入手机号');
        return
      }
      if(!this.verifyCode) {
        this.$message.error('请输入验证码');
        return
      }

      // 证件号必填后，提交前再解析一次性别与生日，避免未失焦导致缺失
      this.parseIdCardInfo();
      
      // 构建注册参数（真实姓名、证件号为必填）
      const registerData = {
        phone: this.phone,
        pin: this.verifyCode,
        name: String(this.realName).trim(),
        idNo: String(this.idNumber).trim()
      };
      
      // 如果从身份证号解析出了性别，添加到参数中
      if(this.sex !== null) {
        registerData.sex = this.sex;
      }
      
      // 如果从身份证号解析出了出生日期，添加到参数中
      if(this.birthday) {
        registerData.birthday = this.birthday;
      }
      
      // 调用注册接口
      register(registerData).then((res) => {
        if(res.code == 1000 || res.code == '1000' || res.code == '0000') {
          // 注册成功
          this.$message.success('注册成功');
          
          // 保存用户信息
          if(res.data) {
            this.setUserInfo(res.data || {});
            if(res.data.token) {
              localStorage.setItem('token', res.data.token);
            }
            if(res.data.userCode) {
              localStorage.setItem('userCode', res.data.userCode);
            }
            
            // 将用户信息传递给原生app
            if (this.$env && this.$env.inDjxApp){
              if (this.$env.inAndroid){
                try {
                  JSInterface.saveUserInfo(JSON.stringify(res.data));
                } catch (error) {
                  console.log(error);
                }
              } else if (this.$env.inIos) {
                try {
                  window.webkit.messageHandlers.saveUserInfo.postMessage(JSON.stringify(res.data));
                } catch (error) {
                  console.log(error);
                }
              }
            }
            
            // 判断是否为新用户，跳转到健康测评分步填写页（原 informationGathering 暂保留）
            if(res.data.isNewUser) {
              this.$router.push({
                path: "/healthAssessFlow",
                query: {}
              });
            } else {
              this.goLandingByBinding();
            }
          }
        } else {
          // 处理各种错误情况
          let errorMsg = res.message || '注册失败，请重试';
          
          // 根据错误码显示不同的提示
          if(res.code == '1000' && res.message && res.message.includes('已注册')) {
            // 手机号已注册，引导用户登录
            this.$confirm('该手机号已注册，是否前往登录？', '提示', {
              confirmButtonText: '去登录',
              cancelButtonText: '取消',
              type: 'info'
            }).then(() => {
              this.$router.push({
                path: "/login",
                query: {}
              });
            });
          } else {
            this.$message.error(errorMsg);
          }
        }
      }).catch((error) => {
        console.error('注册失败:', error);
        this.$message.error('注册失败，请稍后重试');
      });
    },
    /**
     * 按手表绑定状态进入落地页：已绑定→监测，未绑定→健康首页
     * @returns {Promise<void>}
     */
    async goLandingByBinding() {
      clearLandingByBindingFlag();
      try {
        const loc = await resolveLandingLocation();
        markLandingByBindingDone();
        await this.$router.push(loc).catch(() => {});
      } catch (e) {
        await this.$router.push({ name: 'healthAiHome', query: { tab: 'health' } }).catch(() => {});
      }
    },
    agreement() {
      this.$router.push({
        path: "/agreement",
        query:{
        }
      });
    },
    
    /**
     * 跳转到登录页面
     */
    goToLogin() {
      this.$router.push({
        path: "/login",
        query: {}
      });
    },
    /**
     * 从身份证号中解析性别和出生日期
     * @param {Object} event - 输入框失焦事件
     */
    parseIdCardInfo() {
      if (!this.idNumber || this.idNumber.length !== 18) {
        // 重置解析结果
        this.sex = null;
        this.birthday = "";
        return;
      }
      
      // 验证身份证号格式
      if (!this.isValidID(this.idNumber)) {
        // 身份证号格式不正确，重置解析结果
        this.sex = null;
        this.birthday = "";
        return;
      }
      
      // 解析出生日期：身份证号第7-14位为出生日期（YYYYMMDD）
      const birthYear = this.idNumber.substring(6, 10);
      const birthMonth = this.idNumber.substring(10, 12);
      const birthDay = this.idNumber.substring(12, 14);
      
      // 格式化为"YYYY-MM-DD"格式
      this.birthday = `${birthYear}-${birthMonth}-${birthDay}`;
      
      // 解析性别：身份证号第17位（倒数第二位）奇数为男，偶数为女
      const genderCode = parseInt(this.idNumber.substring(16, 17));
      if (genderCode % 2 === 1) {
        // 奇数，男性
        this.sex = 1;
      } else {
        // 偶数，女性
        this.sex = 2;
      }
      
      console.log('从身份证号解析出的信息:', {
        birthday: this.birthday,
        sex: this.sex
      });
    },
    /**
     * 验证身份证号格式
     * @param {String} idNumber - 身份证号
     * @returns {Boolean} 是否有效
     */
    isValidID(idNumber) {
      if (!idNumber || idNumber.length !== 18) {
        return false;
      }
      // 这里简单实现一个身份证校验规则，实际应根据中国大陆的身份证标准进行校验
      if (
        !/^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(
          idNumber
        )
      ) {
        return false; // 格式校验
      }
      var sum = 0;
      var weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
      var checkCodes = ["1", "0", "X", "9", "8", "7", "6", "5", "4", "3", "2"];
      // 计算加权和
      for (var i = 0; i < 17; i++) {
        sum += idNumber.substring(i, i + 1) * weights[i];
      }
      // 计算校验码
      var mod = sum % 11;
      var lastChar = idNumber.substring(17, 18);
      if (checkCodes[mod] !== lastChar) {
        return false; // 校验码校验
      }
      return true;
    },
    /**
     * 获取短信验证码
     */
    getCode() {
      if(!this.phone) {
        this.$message.error('请输入手机号');
        return
      }
      
      pin(this.phone).then((res)=>{
        console.log(res)
        if(res.code == 1000) {
          this.$message.success('验证码已发送');
        }
      }).catch(err => {
        console.log(err)
      })
      
      let that = this;
      let s = 60; //倒计时间
      if (!that.timer) {
        that.second = s;
        that.disabled = true;
        that.timer = setInterval(() => {
          if (that.second > 0 && this.second <= s) {
            that.second--;
          } else {
            that.disabled = false;
            clearInterval(that.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    ...mapActions(useUserStore, ['setUserInfo'])
  }
};
</script>
<style scoped>
/* 主容器 */
.register-container {
  position: relative;
  width: 100%;
  min-height: 100vh;
  overflow-x: hidden;
}

/* 背景层 */
.background-layer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
}

.gradient-bg {
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #A0EDD2 0%, rgba(255, 255, 255, 0.9) 50%, #FFFFFF 100%);
}

.hexagon-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 60%;
  background-image: 
    repeating-linear-gradient(60deg, transparent, transparent 40px, rgba(255,255,255,0.15) 40px, rgba(255,255,255,0.15) 80px),
    repeating-linear-gradient(120deg, transparent, transparent 40px, rgba(255,255,255,0.15) 40px, rgba(255,255,255,0.15) 80px);
  opacity: 0.4;
  background-size: 80px 80px;
}

/* 内容包装器 */
.content-wrapper {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
}

/* 登录头部区域 */
.login-header {
  width: 100%;
  background: url('~@/assets/login/headbackground.png') no-repeat center top;
  background-size: 100% auto;
  background-color: #E5F6F1;
  padding-top: 24px;
  padding-bottom: 20px;
}

.login-header-content {
  text-align: center;
  padding: 0 20px;
  margin-top: 50px;
}

.logo-wrapper {
  position: relative;
  display: inline-block;
  margin-bottom: 18px;
  cursor: pointer;
}

.logo-img {
  width: 58px;
  height: 58px;
  display: block;
  margin: 0 auto;
  border-radius: 8px;
}

.logo-badge {
  position: absolute;
  bottom: -6px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  height: auto;
}

.badge-bg {
  width: 50px;
  height: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.badge-text {
  position: relative;
  font-size: 9px;
  color: #333;
  font-weight: 500;
  z-index: 1;
  white-space: nowrap;
}

.app-name {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  margin-bottom: 5px;
}

/* 特性标签 */
.features {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 16px;
}

.feature-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  background-image: url('~@/assets/login/HeadSubtitleBackground.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  padding: 4px 12px;
  min-width: 60px;
}

.feature-icon {
  width: 16px;
  height: 16px;
  object-fit: contain;
  flex-shrink: 0;
}

.feature-text {
  font-size: 12px;
  color: #333;
  font-weight: 400;
  white-space: nowrap;
}

/* 注册表单卡片 */
.register-card {
  width: 100%;
  max-width: 340px;
  background: #FFFFFF;
  border-radius: 16px;
  padding: 14px 24px;
  margin-bottom: 20px;
  position: relative;
  z-index: 2;
}

.card-title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
  text-align: left;
  margin-bottom: 8px;
}

.card-intro {
  font-size: 12px;
  color: #999;
  text-align: left;
  margin-bottom: 32px;
  line-height: 1.5;
}

/* 输入框字段 */
.input-field {
  margin-bottom: 0;
  display: flex;
  align-items: flex-start;
  padding-bottom: 16px;
  /* border-bottom: 1px dashed #E0E0E0; */
  position: relative;
}

.input-field:last-of-type {
  border-bottom: none;
  padding-bottom: 0;
  margin-bottom: 0;
}

.input-label {
  font-size: 15px;
  color: #000;
  font-weight: 400;
  min-width: 70px;
  text-align: left;
  flex-shrink: 0;
  padding-top: 8px;
  line-height: 1.5;
}

.input-content {
  flex: 1;
  display: flex;
  align-items: center;
  min-height: 40px;
}

.verify-code-content {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
}

.verify-code-content .register-input {
  flex: 1;
  min-width: 0;
  margin-right: 0;
  padding-right: 0;
}

.register-input {
  flex: 1;
  border: none;
  background: transparent;
}

::v-deep .register-input .el-input__inner {
  border: none !important;
  border-width: 0 !important;
  outline: none !important;
  background: transparent !important;
  padding: 8px 0 8px 0 !important;
  font-size: 15px;
  color: #333;
  height: auto;
  min-height: 24px;
  line-height: 1.5;
  box-shadow: none !important;
}

.verify-code-content .register-input ::v-deep .el-input__inner {
  padding-right: 0 !important;
}

::v-deep .register-input .el-input__inner:hover {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .register-input .el-input__inner:focus {
  border: none !important;
  outline: none !important;
  box-shadow: none !important;
}

::v-deep .register-input.is-focus .el-input__inner {
  border: none !important;
  box-shadow: none !important;
}

::v-deep .register-input .el-input__wrapper {
  border: none !important;
  box-shadow: none !important;
  background: transparent !important;
}

::v-deep .register-input .el-input__inner::placeholder {
  color: #999;
}

::v-deep .register-input.el-input--suffix .el-input__inner {
  background: transparent !important;
  border: none !important;
}

/deep/.verify-code-content  .el-input--suffix .el-input__inner {
  padding-right: 0 !important;
}

.verify-code-btn {
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  color: #00BB82;
  font-weight: 400;
  cursor: pointer;
  white-space: nowrap;
  flex-shrink: 0;
  background: linear-gradient(180deg, rgba(0, 187, 130, 0.15) 0%, rgba(0, 187, 130, 0.25) 100%);
  transition: all 0.3s;
  user-select: none;
  height: 32px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: auto;
}
.verify-code-btn:hover:not(.disabled) {
  background: linear-gradient(180deg, rgba(0, 187, 130, 0.2) 0%, rgba(0, 187, 130, 0.3) 100%);
}

.verify-code-btn:active:not(.disabled) {
  background: linear-gradient(180deg, rgba(0, 187, 130, 0.25) 0%, rgba(0, 187, 130, 0.35) 100%);
  transform: scale(0.98);
}

.verify-code-btn.disabled {
  color: #999;
  background: #F5F5F5;
  cursor: not-allowed;
}

/* 注册按钮 */
.register-btn {
  width: 100%;
  height: 48px;
  background: url('~@/assets/login/Loginbuttonbackground.png') no-repeat center center;
  background-size: 100% 100%;
  border: none;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
  cursor: pointer;
  margin-top: 13px;
  margin-bottom: 16px;
  transition: all 0.3s;
}

.register-btn:active {
  opacity: 0.8;
  transform: scale(0.98);
}

/* 用户协议区域 */
.agreement-section {
  width: 100%;
  margin-top: 0;
}

.agreement-checkbox {
  text-align: center;
  display: flex;
  align-items: center;
}

.checkbox-icon {
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}

.checkbox-icon img {
  width: 100%;
  height: 100%;
}

.agreement-text {
  font-size: 12px;
  color: #666;
  line-height: 1.5;
  flex: 1;
}

.link-text {
  color: #00BB82;
  cursor: pointer;
}

/* 已有账号，去登录区域 */
.login-link-section {
  width: 100%;
  margin-top: 20px;
  text-align: center;
}

.login-link-text {
  font-size: 14px;
  color: #999;
  line-height: 1.5;
}

.login-link-btn {
  color: #00BB82;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.3s;
  
  &:hover {
    color: #00a865;
    text-decoration: underline;
  }
  
  &:active {
    opacity: 0.8;
  }
}

/* 响应式设计 */
@media (max-width: 375px) {
  .register-card {
    padding: 14px 20px;
  }
  
  .app-name {
    font-size: 18px;
  }
  
  .features {
    gap: 16px;
  }
}
</style>




// WEBPACK FOOTER //
// src/views/register/index.vue